import React from "react";
import { useRouteError } from "react-router-dom";

function Error() {
  const error = useRouteError();
  return (
    <div>
      <h1>Broken Thread</h1>
      <p>{error.message}</p>
    </div>
  );
}

export default Error;
